import { Link } from 'react-router-dom';
import { GUIDES, PLATFORMS, COMPARISONS } from './links';

const Pill = ({ to, children }) => (
  <Link to={to} className="text-xs font-display font-medium text-ink-secondary bg-white border border-ink-faint/30 hover:border-ink-faint hover:text-ink rounded-full px-3 py-1.5 transition-colors">{children}</Link>
);

const Row = ({ label, items }) => items.length ? (
  <div className="flex flex-wrap items-center gap-2">
    <span className="text-2xs font-mono uppercase tracking-widest text-ink-muted w-full sm:w-24 shrink-0">{label}</span>
    {items.map(({ to, name }) => <Pill key={to} to={to}>{name}</Pill>)}
  </div>
) : null;

/**
 * Cross-links between every public marketing page. `current` is the page's own path,
 * which is omitted from the lists.
 */
export default function RelatedLinks({ current }) {
  const guides = GUIDES.map(g => ({ to: g.path, name: g.name })).filter(g => g.to !== current);
  const platforms = PLATFORMS.map(p => ({ to: `/for/${p.slug}`, name: p.name })).filter(p => p.to !== current);
  const compare = COMPARISONS.map(c => ({ to: `/vs/${c.slug}`, name: `vs ${c.name}` })).filter(c => c.to !== current);
  return (
    <section aria-label="More from Cayda">
      <h2 className="text-xl font-display font-bold text-ink tracking-tight mb-5">Keep reading</h2>
      <div className="space-y-3">
        <Row label="Guides" items={guides} />
        <Row label="Cayda for" items={platforms} />
        <Row label="Compare" items={compare} />
      </div>
    </section>
  );
}
